export enum graphqlErrorCodes {
  BAD_USER_INPUT = 'BAD_USER_INPUT'
}
